import {
  useGetPublicOrganizationDetail,
  useGetPublicStrukturOrganisasiPeriode,
} from '@tatatemplate/shared-lib'

export const useDesaDetail = () => {
  return useGetPublicOrganizationDetail({
    query: {
      queryKey: ['desa', 'detail'],
      select: (res) => res.data,
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  })
}

export const useStrukturPemerintahan = () => {
  return useGetPublicStrukturOrganisasiPeriode({
    query: {
      queryKey: ['pemerintahdesa', 'struktur', 'details'],
      select: (res) => res.data,
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  })
}
